import { Badge } from "@chakra-ui/react";

const BadgeUserRole = ({ data }) => {
    let color = "gray"
    let text = data.role_name || "ไม่ระบุ"

    switch (data.role_id) {
        case 1:
            color = "blue"
            break;
        case 2:
            color = "orange"
            break;
        case 3:
            color = "pink"
            break;
        case 4:
            color = "yellow"
            break;
        case 5:
            color = "green"
            break;
        default: color = "green"
    }

    return (
        <Badge colorScheme={color}>{text}</Badge>
    )
}

export default BadgeUserRole